import { localStorageUtils } from 'shared/utils';

export const defaultPagination = {
  rowsPerPage: 20,
  currentPage: (keyName?: string) => (keyName ? Number(localStorageUtils.get(keyName) || 0) : 0)
};
